import TextBoundaryComponent from '../Component/TextBoundary';
import Point from '../Utility/Point';
import TextComponent from '../Component/Render/Text';
import * as PIXI from 'pixi.js';
import GameObject from '../GameObject/GameObject';
import TransformComponent from '../Component/Transform';
import RelativePositionComponent from '../Component/Render/RelativePosition';

export default class Text extends GameObject<PIXI.Text> {
    protected instantiateContainer(params: any): void {
        this.container = new PIXI.Text(params.text, params.style);
    }

    protected onCreate(params: {
        text: string;
        position?: Point;
        anchor?: Point;
        style: PIXI.TextStyleOptions;
        relativePosition?: Point;
        bounds?: Point;
    }): void {
        this.addComponent(TransformComponent, params);
        this.addComponent(TextComponent, params);

        if (params.bounds) {
            this.addComponent<TextBoundaryComponent>(
                TextBoundaryComponent,
                params
            );
        }

        if (params.relativePosition) {
            this.addComponent<RelativePositionComponent>(
                RelativePositionComponent,
                params
            );
        }
    }
}
